import { gql } from "@apollo/client";

const AvailableProjectsSubscription = gql`
  subscription AvailableProjects {
    listen(topic: "project_update") {
      query {
        allProjects(condition: { isActive: true }, orderBy: PROJECT_NAME_ASC) {
          nodes {
            projectName
          }
        }
      }
    }
  }
`;

const hash = "b06a083287cf383f5cfeafba92e6dc0c59a78723b5b17b0d39c7e8fc4e58e05c";

export { AvailableProjectsSubscription, hash };
